import { combineReducers, Reducer } from 'redux';
import { SurveysReducer } from './surveys';
import { SurveysResponseReducer } from './surveysResponse';
import { UserReducer } from './users';
import { CoachingSessionsReducer } from './coachingSessions';
import { TasksReducer } from './tasks';
import { ContentReducer } from './content';
import { GroupsReducer } from './groups';

export const allReducers: Reducer = combineReducers({
  surveys: SurveysReducer,
  coachingSessionsReducer: CoachingSessionsReducer,
  surveysResponse: SurveysResponseReducer,
  users: UserReducer,
  tasks: TasksReducer,
  content: ContentReducer,
  groups: GroupsReducer
});
